import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, SearchBar } from "../../components";
import {
  getCurrentDateTime,
  getFutureDateTime,
  formatDateString,
} from "../../util/time";
import {
  refusePaymentWithCash,
  getDebtDriveSchool,
  activeUserGuest,
  getMovmentDriveSchool,
  setPage,
} from "../../store/slices/userDriveSchoolSlice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import mosbarazimi from "../../../src/assets/mosbarazimi.png";
import qarkullimi from "../../../src/assets/qarkullimi.png";
import barazimet from "../../../src/assets/barazimet.png";
import pagesat from "../../../src/assets/pagesat.png";

const MovmentDriveSchool = () => {
  const dispatch = useDispatch();
  const dataMovment = useSelector(
    (state) => state.userDriveSchoolSlice.dataMovment
  );
  const [pay, setPay] = useState(false);
  const debt = useSelector((state) => state.userDriveSchoolSlice.debt);

  const totalCalculation = dataMovment?.totalCalculation || 0;
  const profitDriveSchool = dataMovment?.profitDriveSchool || 0;
  const remainingBalance = dataMovment?.remaining_balance || 0;

  const totalCount = useSelector(
    (state) => state.userDriveSchoolSlice.totalCount
  );
  const currentPage = useSelector(
    (state) => state.userDriveSchoolSlice.currentPage
  );
  const isLoading = useSelector((state) => state.userDriveSchoolSlice.loading);

  const [searchInput, setSearchInput] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const isSelected = (status) => selectedStatus === status;

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isLoading) {
        dispatch(
          getMovmentDriveSchool({
            page: currentPage,
            searchQuery: searchInput,
            statusFilter: selectedStatus,
          })
        );
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [dispatch, currentPage, searchInput, selectedStatus, isLoading]);

  const handelActiveUser = async (id, userId, catId, driveSchoolId, month) => {
    const data = {
      id,
      userId,
      catId,
      activeStart: getCurrentDateTime(),
      activeEnd: getFutureDateTime(month),
      driveSchoolId,
    };

    try {
      await dispatch(activeUserGuest(data)).unwrap();
      toast.success("Kandidati u aktivizua me sukses");

      dispatch(
        getMovmentDriveSchool({
          page: currentPage,
          searchQuery: searchInput,
          statusFilter: selectedStatus,
        })
      );
    } catch (error) {
      toast.error("Gabim gjatë aktivizimit");
    }
  };

  const handleRefuse = async (catId, packageId, userId, paymentId) => {
    try {
      await dispatch(
        refusePaymentWithCash({ catId, packageId, userId, paymentId })
      ).unwrap();
      toast.error("Kandiadti u refuzua");
      setTimeout(() => {
        dispatch(
          getMovmentDriveSchool({
            page: currentPage,
            searchQuery: searchInput,
            statusFilter: selectedStatus,
          })
        );
      }, 1000);
    } catch (error) {
      toast.error("Gabim gjatë refuzimit");
    }
  };

  useEffect(() => {
    dispatch(
      getMovmentDriveSchool({
        page: currentPage,
        searchQuery: searchInput,
        statusFilter: selectedStatus,
      })
    );
  }, [dispatch, currentPage, searchInput, selectedStatus]);

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(
      getMovmentDriveSchool({
        page: currentPage,
        searchQuery: searchInput,
        statusFilter: selectedStatus,
      })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  useEffect(() => {
    dispatch(getDebtDriveSchool());
  }, []);

  return (
    <div className="pt-[80px]">
      <p className="text-xl mb-4 text-left pl-6 pb-4">
        Qarkullimi i autoshkollës dhe aktivizimi i kandidatëve
      </p>
      <div className="hidden md:flex flex-wrap justify-center gap-4 mb-10">
        <div className="min-w-[250px] max-w-[220px] flex items-center bg-white shadow-md rounded-2xl p-6">
          <div className="bg-[#FFF5D9] rounded-full p-3 mr-4">
            <img src={qarkullimi} alt="Qarkullimi" />
          </div>
          <div>
            <p className="text-[#718EBF] text-sm">Qarkullimi</p>
            <p className="text-black text-lg font-bold">{totalCalculation} €</p>
          </div>
        </div>

        <div className="col-span-1 md:min-w-[250px] md:max-w-[220px] flex items-center bg-white shadow-md rounded-2xl p-6">
          <div className="bg-[#CFEDD2] rounded-full p-3 mr-4">
            <img src={pagesat} alt="Fitimi" />
          </div>
          <div>
            <p className="text-[#718EBF] text-sm">Fitimi i autoshkollave</p>
            <p className="text-black text-lg font-bold">
              {profitDriveSchool} €
            </p>
          </div>
        </div>

        <div className="col-span-1 md:min-w-[250px] md:max-w-[220px] flex items-center bg-white shadow-md rounded-2xl p-6">
          <div className="bg-[#F5CBC9] rounded-full p-3 mr-4">
            <img src={mosbarazimi} alt="Mosbarazimi" />
          </div>
          <div>
            <p className="text-[#718EBF] text-sm">Mosbarazimi</p>
            <p className="text-black text-lg font-bold">{remainingBalance} €</p>
          </div>
        </div>

        <button
          className="col-span-1 md:min-w-[250px] md:max-w-[220px] flex items-center bg-white shadow-md rounded-2xl p-6"
          onClick={() => setPay(!pay)}
        >
          <div className="bg-[#E7EDFF] rounded-full p-3 mr-4">
            <img src={barazimet} alt="Barazimet" />
          </div>
          <p className="text-[#718EBF] text-sm">Lista e barazimeve</p>
        </button>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-10 md:hidden">
        <div className="flex items-center bg-white shadow-md rounded-2xl p-6">
          <div className="bg-[#FFF5D9] rounded-full p-1 mr-2">
            <img src={qarkullimi} alt="Qarkullimi" />
          </div>
          <div>
            <p className="text-[#718EBF] text-sm">Qarkullimi</p>
            <p className="text-black text-lg font-bold">{totalCalculation} €</p>
          </div>
        </div>

        <div className="flex items-center bg-white shadow-md rounded-2xl p-4">
          <div className="bg-[#CFEDD2] rounded-full p-1 mr-2">
            <img src={pagesat} alt="Fitimi" />
          </div>
          <div>
            <p className="text-[#718EBF] text-sm">Fitimi i autoshkollave</p>
            <p className="text-black text-lg font-bold">
              {profitDriveSchool} €
            </p>
          </div>
        </div>

        <div className="flex items-center bg-white shadow-md rounded-2xl p-4">
          <div className="bg-[#F5CBC9] rounded-full p-1 mr-2">
            <img src={mosbarazimi} alt="Mosbarazimi" />
          </div>
          <div>
            <p className="text-[#718EBF] text-sm">Mosbarazimi</p>
            <p className="text-black text-lg font-bold">{remainingBalance} €</p>
          </div>
        </div>

        <button
          className="flex items-center bg-white shadow-md rounded-2xl p-4"
          onClick={() => setPay(!pay)}
        >
          <div className="bg-[#E7EDFF] rounded-full p-1 mr-2">
            <img src={barazimet} alt="Barazimet" />
          </div>
          <p className="text-[#718EBF] text-sm">Lista e barazimeve</p>
        </button>
      </div>

      <div className="flex flex-wrap justify-center gap-4 p-4">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />

        {[
          {
            key: "",
            label: "Të gjitha abonimet",
            bg: "bg-[#396AFF]",
            selectedBg: "bg-blue-700",
            border: "border-blue-800",
          },
          {
            key: "pending",
            label: "Abonimet në pritje",
            bg: "bg-[#FFBB38]",
            selectedBg: "bg-yellow-600",
            border: "border-yellow-700",
          },
          {
            key: "approved",
            label: "Abonimet e aktivizuara",
            bg: "bg-[#5EC269]",
            selectedBg: "bg-green-700",
            border: "border-green-800",
          },
          {
            key: "expired",
            label: "Abonimet e skaduara",
            bg: "bg-[#DD524C]",
            selectedBg: "bg-red-700",
            border: "border-red-800",
          },
        ].map(({ key, label, bg, selectedBg, border }) => (
          <div
            key={key}
            className={`block w-full md:w-60 p-3 text-sm border rounded-2xl text-center cursor-pointer transform transition-all duration-300 ease-in-out
        ${
          isSelected(key)
            ? `${selectedBg} text-white ${border} shadow-xl scale-105 -translate-y-1`
            : `${bg} text-white border-gray-300`
        }`}
            onClick={() => setSelectedStatus(key)}
          >
            <p className="font-semibold tracking-wide">{label}</p>
          </div>
        ))}
      </div>

      <div className="block md:hidden space-y-4 mt-4">
        {dataMovment?.data?.map((item) => (
          <div
            key={item.payment_id}
            className="bg-white shadow-md rounded-2xl p-4"
          >
            <p className="text-sm mb-1">
              <span className="font-semibold">Kandidati:</span> {item.name}
            </p>
            <p className="text-sm">
              <span className="font-semibold">Kategoria:</span> {item.catName}
            </p>
            <p className="text-sm">
              <span className="font-semibold">Pako:</span> {item.package}
            </p>
            <p className="text-sm">
              <span className="font-semibold">Mënyra e pagesës:</span>{" "}
              {item.cash === 1 ? "Para në dorë" : "Përmes bankës"}
            </p>
            <p className="text-sm text-[#FFC500] mt-2">
              <span className="font-semibold">Për pagesë:</span> {item.amount}€
            </p>
            <p className="text-sm">
              <span className="font-semibold">Skadon më:</span>{" "}
              {formatDateString(item.activeEnd)}
            </p>
            <p className="text-sm">
              <span className="font-semibold">Statusi:</span>{" "}
              {item.status === "approved" ? (
                <span className="text-green-600 font-bold">Aktiv</span>
              ) : item.status === "expired" ? (
                <span className="text-red-600 font-bold">Skaduar</span>
              ) : item.status === "pending" ? (
                <span className="text-yellow-500 font-bold">Ne pritje</span>
              ) : (
                <span className="text-gray-500 font-bold">Pa status</span>
              )}
            </p>
            <p className="text-sm">
              <span className="font-semibold">Bilanci:</span>{" "}
              {item.cash === 1 ? (
                <span className="text-red-600">- {item.adminPrice} €</span>
              ) : (
                <span className="text-green-600">+ {item.schoolPrice} €</span>
              )}
            </p>

            <div className="flex mt-3 gap-2">
              {item.user_id ? (
                item.isActive ? (
                  <button className="bg-green-500 w-full text-white font-bold py-2 rounded-full">
                    Aktivizuar
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() =>
                        handelActiveUser(
                          item.payment_id,
                          item.user_id,
                          item.category_id,
                          item.driveSchool_id,
                          item.month
                        )
                      }
                      className="bg-green-500 w-full text-white font-bold py-2 rounded-full"
                    >
                      Aktivizo
                    </button>
                    <button
                      onClick={() =>
                        handleRefuse(
                          item.category_id,
                          item.packageId,
                          item.user_id,
                          item.payment_id
                        )
                      }
                      className="bg-red-500 w-full text-white font-bold py-2 rounded-full"
                    >
                      Refuzo
                    </button>
                  </>
                )
              ) : item.isActive ? (
                <button className="bg-green-500 w-full text-white font-bold py-2 rounded-full">
                  Aktivizuar
                </button>
              ) : (
                <button
                  onClick={() =>
                    handleRefuse(
                      item.category_id,
                      item.packageId,
                      item.user_id,
                      item.payment_id
                    )
                  }
                  className="bg-red-500 w-full text-white font-bold py-2 rounded-full"
                >
                  Refuzo
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="hidden md:block">
        <div className="m-2 md:m-0 p-2 md:p-6 bg-white rounded-3xl">
          <div className="p-3">
            <div
              className="relative overflow-x-auto shadow-md sm:rounded-lg"
              style={{ borderRadius: 1 }}
            >
              <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="px-6 py-3">
                      Kandidati
                    </th>

                    <th scope="col" className="px-6 py-3">
                      Kategoria
                    </th>

                    <th scope="col" className="px-6 py-3">
                      Pako
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Menyra e pageses
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Per pages
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Skadon Me
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Statusi
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Bilanci
                    </th>
                    <th scope="col" className="px-6 py-3">
                      Aksion
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataMovment?.data
                    ?.filter((item) => item.user_id && item.name)
                    .map((item) => {
                      return (
                        <tr
                          key={item}
                          className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                        >
                          <td className="px-6 py-4">{item.name}</td>
                          <td className="px-6 py-4">{item.catName}</td>
                          <td className="px-6 py-4">{item.package}</td>
                          <td className="px-6 py-4">
                            {item.cash === 1 ? "Para ne dore" : "Permes Bankes"}
                          </td>
                          <td className="px-6 py-4 text-[#FFC500] font-bold">
                            {item.amount} €
                          </td>
                          <td className="px-6 py-4 font-bold">
                            {item.activeEnd
                              ? formatDateString(item.activeEnd)
                              : ""}
                          </td>
                          <td className="px-6 py-4">
                            {item.status === "approved" ? (
                              <span className="text-green-500 font-bold">
                                Aktiv
                              </span>
                            ) : item.status === "expired" ? (
                              <span className="text-red-500 font-bold">
                                Skaduar
                              </span>
                            ) : item.status === "pending" ? (
                              <span className="text-[#FFC500] font-bold">
                                Ne Pritje
                              </span>
                            ) : (
                              <span className="text-gray-500 font-bold">
                                Pa Status
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 font-bold">
                            <span className="text-red-500">
                              {item.cash === 1 ? (
                                `- ${item.adminPrice}`
                              ) : (
                                <span className="text-green-500">
                                  + {item.schoolPrice} €
                                </span>
                              )}
                            </span>
                          </td>
                          <td className="px-6 py-4 flex">
                            {item.user_id ? (
                              item.isActive ? (
                                <button className="bg-green-500  text-white font-bold py-2 px-8 rounded-full">
                                  Aktivizuar
                                </button>
                              ) : (
                                <>
                                  <button
                                    onClick={() =>
                                      handelActiveUser(
                                        item.payment_id,
                                        item.user_id,
                                        item.category_id,
                                        item.driveSchool_id,
                                        item.month
                                      )
                                    }
                                    className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full"
                                  >
                                    Aktivizo
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleRefuse(
                                        item.category_id,
                                        item.packageId,
                                        item.user_id,
                                        item.payment_id
                                      )
                                    }
                                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4  rounded-full"
                                  >
                                    Refuzo
                                  </button>
                                </>
                              )
                            ) : item.isActive ? (
                              <button className="bg-green-500  text-white font-bold py-2 px-4 rounded-full">
                                Aktivizuar
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  handleRefuse(
                                    item.category_id,
                                    item.packageId,
                                    item.user_id,
                                    item.payment_id
                                  )
                                }
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4  rounded-[20px]"
                              >
                                Refuzo
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalCount={totalCount}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="block md:hidden mt-6">
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>

      {pay && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-2 sm:px-4">
          {/* Overlay */}
          <div
            className="bg-gray-900 bg-opacity-40 absolute inset-0"
            onClick={() => setPay(false)}
          ></div>

          {/* Modal */}
          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-2xl p-4 sm:p-6 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg sm:text-xl font-semibold text-center flex-grow">
                Lista e Barazimeve
              </h3>
              <button
                onClick={() => setPay(false)}
                className="text-gray-600 hover:text-gray-800 font-bold text-xl leading-none"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {debt.length === 0 ? (
              <p className="text-center text-gray-500">
                Nuk ka pagesa të regjistruara.
              </p>
            ) : (
              <div className="w-full">
                <table className="w-full text-sm text-left border border-gray-200 rounded-md table-fixed">
                  <thead className="bg-gray-100 text-[#7B8BB2]">
                    <tr>
                      <th className="px-2 sm:px-4 py-2 border-b border-gray-300 w-1/3 break-words">
                        Data pageses
                      </th>
                      <th className="px-2 sm:px-4 py-2 border-b border-gray-300 w-1/3 break-words">
                        Shuma e pageses
                      </th>
                      <th className="px-2 sm:px-4 py-2 border-b border-gray-300 w-1/3 break-words">
                        Përshkrimi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {debt.map((item) => (
                      <tr key={item.id} className="text-black even:bg-gray-50">
                        <td className="py-2 px-2 sm:px-4 break-words">
                          {new Date(item.create_at).toLocaleString("sq-AL", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </td>
                        <td className="py-2 px-2 sm:px-4 break-words">
                          {item.amount}€
                        </td>
                        <td className="py-2 px-2 sm:px-4 break-words">
                          {item.description || "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MovmentDriveSchool;
